import { useCallback } from 'react';

export type {
	CommentLocation as InlineCommentLocation,
	GeneralCommentLocation,
} from '@confluence/inline-comments-queries';

export {
	useCommentsData,
	useCommentsDataActions,
	useCommentsDataState,
	CommentsDataStore,
	type CommentData,
	type CommentsDataMap,
	type DataMap,
	type CommentsDataState,
	type ReplyData,
	type AnnotationStatus,
	type RemovedThreadsCommentTypeMap,
	CommentType,
	UnreadAction,
	CommentActionType,
} from './useCommentsData';
export {
	useActiveInlineCommentsQuery,
	COMMENT_BATCH_SIZE,
} from './hooks/useActiveInlineCommentsQuery';
export { useActiveCommentsQuery } from './hooks/useActiveCommentsQuery';
export { useResolvedCommentsQuery } from './hooks/useResolvedCommentsQuery';
export {
	updateCommentsDataState,
	normalizeCommentData,
	findCommentById,
	getTopLevelParentComment,
} from './helper/commentsDataHelper';

export const useUpdateAnnotations = (callbacks: ((annotations: string[]) => void)[]) =>
	useCallback((annotationsList: string[]) => {
		callbacks.forEach((callback) => callback(annotationsList));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, callbacks);
